import { object, string, boolean, date } from 'yup'
import { sub, isPast } from 'date-fns'
import { nameStringSchema } from './nameSchema'

export enum BiographicSearchKeys {
  FIRST_NAME = 'firstName',
  MIDDLE_NAME = 'middleName',
  NO_MIDDLE_NAME = 'noMiddleName',
  LAST_NAME = 'lastName',
  DOB = 'dob',
  COUNTRY_OF_BIRTH = 'countryOfBirth',
  SUFFIX = 'suffix',
}

export const BiographicSearchLabels = {
  [BiographicSearchKeys.FIRST_NAME]: 'First Name',
  [BiographicSearchKeys.NO_MIDDLE_NAME]: 'No Middle Name',
  [BiographicSearchKeys.MIDDLE_NAME]: 'Middle Name',
  [BiographicSearchKeys.LAST_NAME]: 'Last Name',
  [BiographicSearchKeys.DOB]: 'Date of Birth',
  [BiographicSearchKeys.COUNTRY_OF_BIRTH]: 'Country of Birth',
  [BiographicSearchKeys.SUFFIX]: 'Suffix (Optional)',
}

export const biographicSearchSchema = object().shape({
  [BiographicSearchKeys.FIRST_NAME]: nameStringSchema
    .required()
    .label('firstName'),
  [BiographicSearchKeys.NO_MIDDLE_NAME]: boolean().required(),
  [BiographicSearchKeys.MIDDLE_NAME]: string().when('noMiddleName', {
    is: false,
    then: nameStringSchema.required().label('middleName'),
    otherwise: string().notRequired(),
  }),
  [BiographicSearchKeys.LAST_NAME]: nameStringSchema
    .required()
    .label('lastName'),
  [BiographicSearchKeys.DOB]: date()
    .required()
    .test('is-past', 'Date must be in the past.', (value) =>
      isPast(value || new Date())
    )
    .max(
      sub(new Date(), { years: 5 }),
      'Applicants must be at least 5 years or older.'
    )
    .min(
      sub(new Date(), { years: 115 }),
      'Applicants must be less than 115 years old.'
    )
    .typeError('Invalid Date'),
  [BiographicSearchKeys.COUNTRY_OF_BIRTH]: string().required('Required'),
})
